import RepositorySearch from "./RepositorySearch.js";
import Validates from "./mixins/validates-items";

export default RepositorySearch.extend({
    mixins: [Validates],
    data() {
        return {
            modal: {
                active: false,
                fresh: false,
                modified: false,
                old: {},
                item: {}
            },
            options: {
                name: "",
            },
            sortColumn: "name",
            limit: 50,
            messages: {
                validate: {
                    name: "Необходимо указать верное название",
                },
                remove: {
                    title: "Удаление",
                    message: "Действительно удалить?",
                    confirm: "Удалить",
                    cancel: "Отмена",
                    success: "Успешно удалено"
                }
            },
            default: {},
        };
    },
    methods: {
        /**
         * Promise-based before open interception
         */
        beforeOpen(item) {
            // Dummy promise
            return new Promise((resolve) => {
                resolve();
            });
        },
        beforeSave(item) {
            return new Promise((resolve, reject) => {
                if (item.name && !item.name.length) {
                    this.modal.modified = false;
                    reject();
                }
                resolve();
            });
        },
        clear: function () {
            this.options.name = "";
        },
        open: function (item) {
            this.beforeOpen(item).then(() => {
                this.modal.fresh = !item;
                if (this.modal.fresh) {
                    item = _.clone(this.default);
                    this.modal.old = {};
                } else {
                    this.modal.old = _.clone(item);
                }
                this.modal.item = _.clone(item);
                this.modal.active = true;
            }).catch(() => { })
        },
        create: function () {
            this.open();
        },
        save: function (item) {
            this.beforeSave(item).then(() => {
                if (!this.modal.modified) {
                    return;
                }

                if (this.modal.fresh) {
                    this.$validator.validateAll().then(valid => {
                        if (!valid) {
                            this.toast("error", this.messages.validate.name);
                            this.modal.modified = false;
                            return;
                        }
                        this.initiateLoad(
                            source => {
                                axios
                                    .post(this.endpoint, item)
                                    .then(response => {
                                        _.delay(() => {
                                            this.modal.modified = false;
                                            this.modal.active = false;
                                            this.finishLoad();
                                            this.search(true);
                                        }, 500);
                                    })
                                    .catch(error => {
                                        this.finishLoad();
                                        switch (error.response.status) {
                                            case 422: {
                                                let data = error.response.data;
                                                let errors = data.errors;
                                                let errorKeys = Object.keys(errors);

                                                if (errorKeys.length > 0) {
                                                    this.toast("error", errors[errorKeys[0]][0]);
                                                } else {
                                                    this.toast("error", data.message);
                                                }
                                                break;
                                            }
                                            case 403: {
                                                this.toast(
                                                    "warning",
                                                    "Создание с такими параметрами недоступно"
                                                );
                                                break;
                                            }
                                            default: {

                                                this.toast("error", "@unexpected", error);
                                                break;
                                            }
                                        }
                                    });
                            },
                            source => {
                                source.cancel("timeout");
                            }
                        );
                    });
                } else {
                    this.initiateLoad(
                        source => {
                            axios
                                .put(`${this.endpoint}${item.id}`, item)
                                .then(response => {
                                    _.delay(() => {
                                        this.modal.modified = false;
                                        this.modal.active = false;
                                        this.finishLoad();
                                        this.search(true);
                                    }, 500);
                                })
                                .catch(error => {
                                    this.finishLoad();
                                    switch (error.response.status) {
                                        case 422: {
                                            let data = error.response.data;
                                            let errors = data.errors;
                                            let errorKeys = Object.keys(errors);

                                            if (errorKeys.length > 0) {
                                                this.toast("error", errors[errorKeys[0]][0]);
                                            } else {
                                                this.toast("error", data.message);
                                            }
                                            break;
                                        }
                                        case 403: {
                                            this.toast(
                                                "warning",
                                                "Сохранение с такими параметрами недоступно"
                                            );
                                            break;
                                        }
                                        default: {

                                            this.toast("error", "@unexpected", error);
                                            break;
                                        }
                                    }
                                });
                        },
                        source => {
                            source.cancel("timeout");
                        }
                    );
                }
            }).catch(() => { })
        },
        remove: function (item) {
            if (item) {
                this.$dialog.confirm({
                    title: this.messages.remove.title,
                    message: this.messages.remove.message,
                    confirmText: this.messages.remove.confirm,
                    cancelText: this.messages.remove.cancel,
                    type: "is-danger",
                    hasIcon: true,
                    onConfirm: () => {
                        let loading = this.$loading.open();

                        axios
                            .delete(`${this.endpoint}${item.id}`)
                            .then(response => {
                                loading.close();
                                this.toast("success", this.messages.remove.success);
                                this.modal.active = false;
                                this.finishLoad();
                                this.search(true);
                            })
                            .catch(error => {
                                this.finishLoad();
                                this.toast("error", "@unexpected", error);
                            });
                    }
                });
            }
        },
        close: function () {
            this.modal.item.name = this.modal.old.name;
            this.modal.active = false;
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/abstract/ItemIndex.js